import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';
import { compressImage } from '../lib/compressImage.js';

// Tickets photographiés au moment du paiement (rapprochement unitaire, hors import PDF en lot).

export function useReceipts(status) {
  const qs = status ? `?status=${status}` : '';
  return useQuery({
    queryKey: ['receipts', status ?? 'default'],
    queryFn: () => api.get(`/receipts${qs}`),
  });
}

export function useUploadReceipt() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (file) => {
      const blob = await compressImage(file);
      const fd = new FormData();
      fd.append('file', blob, 'ticket.jpg');
      return api.upload('/receipts', fd);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['receipts'] }),
  });
}

export function useConfirmReceipt() {
  const qc = useQueryClient();
  return useMutation({
    // category_id omis quand rien n'est choisi ; la TVA n'est envoyée que si l'utilisateur l'a modifiée.
    mutationFn: ({ id, transaction_id, entity_id, category_id, vat_rate, vat_amount_cents, vat_breakdown }) =>
      api.post(`/receipts/${id}/confirm`, {
        transaction_id,
        entity_id,
        ...(category_id ? { category_id } : {}),
        ...(vat_rate !== undefined || vat_amount_cents !== undefined
          ? { vat_rate: vat_rate ?? null, vat_amount_cents: vat_amount_cents ?? null }
          : {}),
        ...(vat_breakdown ? { vat_breakdown } : {}),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['receipts'] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
      qc.invalidateQueries({ queryKey: ['cash-flow'] });
    },
  });
}

export function useDismissReceipt() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.post(`/receipts/${id}/dismiss`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['receipts'] }),
  });
}

export function useRejectReceipt() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.post(`/receipts/${id}/reject`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['receipts'] }),
  });
}
